import styled from "styled-components";
import { GenericSvg, SVGName } from "../../../assets/svgs/GenericSVG";
import { Body } from "../../styles/stringStyles";
import { useStyles } from "../../styles/theme";
import { hexWithOpacity } from "../../utils/helpers";
import { CustomButton } from "./CustomButton";

type Props = {
  isChecked?: boolean;
  text: string;
  onPress: (newValue: boolean) => void;
  checkBoxIconName?: SVGName;
};

export const RadioButtonWithLabel = ({
  isChecked,
  text,
  onPress,
  checkBoxIconName,
}: Props) => {
  const theme = useStyles();
  return (
    <CheckboxContainer $checked={isChecked} onClick={() => onPress(!isChecked)}>
      <GenericSvg
        name={
          isChecked ? "Checkmark" : checkBoxIconName ?? "CheckBoxRoundInactive"
        }
        primaryColor={
          isChecked
            ? theme.colors.white
            : hexWithOpacity(theme.colors.medium, 0.3)
        }
        width={18}
        height={18}
      />
      <StyledBody $checked={isChecked}>{text}</StyledBody>
    </CheckboxContainer>
  );
};

const CheckboxContainer = styled(CustomButton)<{ $checked?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: ${({ theme, $checked }) =>
    $checked ? theme.colors.primary : hexWithOpacity(theme.colors.light, 0.4)};
`;

const StyledBody = styled(Body)<{ $checked?: boolean }>`
  color: ${({ theme, $checked }) =>
    $checked ? theme.colors.white : theme.colors.medium};
  text-align: left;
  width: 80%;
`;
